// This icon file is generated automatically.
var PAlignLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M.88 2.6h7.75c.06 0 .12-.06.12-.13v-.88a.13.13 0 00-.13-.12H.88a.13.13 0 00-.13.12v.88c0 .07.06.12.13.12zm0 6.62h7.75c.06 0 .12-.06.12-.13v-.87a.13.13 0 00-.13-.13H.88a.13.13 0 00-.13.13v.87c0 .07.06.13.13.13zm12.24 2.19H.88a.13.13 0 00-.13.12v.88c0 .06.06.12.13.12h12.24c.07 0 .13-.05.13-.12v-.88a.13.13 0 00-.13-.12zm0-6.63H.88a.13.13 0 00-.13.13v.87c0 .07.06.13.13.13h12.24c.07 0 .13-.06.13-.13v-.87a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-align-left", "theme": "outlined" };
export default PAlignLeftOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PAlignLeftOutlined.js
// module id = 3198
// module chunks = 0